module.exports = __webpack_public_path__ + "img/flag.4ad6179f.svg";